/**
 * Katerina Art — Global JS Utilities
 * Minimal, purposeful JavaScript for the brutalist gallery aesthetic
 */
const katerina = {
  /**
   * Initialize IntersectionObserver-based scroll reveal animations
   */
  initReveal() {
    const elements = document.querySelectorAll('.reveal');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    elements.forEach((el) => observer.observe(el));
  },

  /**
   * Smooth-scroll anchor links
   */
  initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const target = document.querySelector(anchor.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  },

  /**
   * Mobile menu toggle
   */
  initMobileMenu() {
    const toggle = document.getElementById('mobile-menu-toggle');
    const drawer = document.getElementById('mobile-menu-drawer');
    const overlay = document.getElementById('mobile-menu-overlay');
    if (!toggle || !drawer) return;

    const open = () => {
      drawer.classList.add('is-open');
      overlay?.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      drawer.classList.remove('is-open');
      overlay?.classList.remove('is-visible');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', () => {
      drawer.classList.contains('is-open') ? close() : open();
    });

    overlay?.addEventListener('click', close);

    document.querySelectorAll('.mobile-menu-close').forEach((btn) => {
      btn.addEventListener('click', close);
    });
  },
};

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  katerina.initReveal();
  katerina.initSmoothScroll();
  katerina.initMobileMenu();
});

// Expose globally for Shopify theme editor
window.katerina = katerina;
